export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4679.2ecc0f31.jpg";